import React from "react";
import {Button, Form, Input} from 'antd';

const FormItem = Form.Item;


export default ({setSearchForm, searchClick, searchForm, modalShow}) => {
  return (
      <Form layout="inline" style={{textAlign: 'left', paddingTop: 10, paddingBottom: 10}}>
        <FormItem label="产品名称">
          <Input
              placeholder="请输入产品名称"
              value={searchForm.get('productName')}
              onChange={(e) => setSearchForm({key: "productName", value: e.target.value})}
          />
        </FormItem>
        <FormItem>
          <Button type="primary" onClick={() => searchClick()}>查询</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" onClick={() => modalShow(1)}>新增</Button>
        </FormItem>
      </Form>
  )
}


